import React, { Component } from "react";
import { Modal } from "antd";
import { ajax } from "utils/common";
import "./index.less";
//图片
import videoCancel from "images/video-model-cancel.png";
import NotStart from "images/status-not-start.png";
import Finished from "images/status-finished.png";
import Resume from "images/status-resume.png";
import Device from "images/status-device.png";
import NotSupport from "images/status-not-support.png";
import Offline from "images/status-offline.png";

function App(props){
    const { i18n, status, userInfo, message } = props;
    const accessNum = userInfo?userInfo.accessNum:0;
    const canVisitsTimes = userInfo?(userInfo.canVisits || 3):3;
    //获取浏览器类型
    const userAgent = navigator.userAgent;
    const isChrome = userAgent.indexOf("Chrome") >= 0 ? true : false;
    const isFirefox = userAgent.indexOf("Firefox") >= 0 ? true : false;
    const isSafari = userAgent.indexOf("Macintosh") >= 0  ? true : false;
    //获取网站origin
    const origin = location.origin;

    // 踢掉其他设备
    const handleKickOther = () => {
        ajax({
            url: "/account/kickOther",
            data: {}
        }).then(res => {
            window.location.reload();
	    }).catch(err => {
            Modal.info({
                title: i18n.showModal.title,
                content: err.message || "系统错误",
                okText: i18n.device.btnText,
                onOk() {}
            })
        })
    }

    //不同状态
    if(status === 1){
        return (
            <div className="status-wrap">
                <img className="status-logo" src={NotStart} />
                <p className="status-title">{message || i18n.globalStatus.status1Text1}</p>
                <p className="status-subtitle">{i18n.globalStatus.status1Text2}：{ userInfo.startTimeStr } - { userInfo.endTimeStr }</p>
                <div className="status-btn status-btn-blank" onClick={props.hideModal}>{i18n.globalStatus.statusBtnText1}</div>
            </div>
        )
    }else if(status === 2){
        return (
            <div className="status-wrap">
                <img className="status-logo" src={Finished} />
                <p className="status-title">{i18n.globalStatus.status2Text1 + i18n.globalStatus.status2Text2}</p>
                <p className="status-subtitle">{i18n.globalStatus.status2Text3}：{ userInfo.startTimeStr } - { userInfo.endTimeStr }</p>
                <div className="status-btn status-btn-blank" onClick={props.hideModal}>{i18n.globalStatus.statusBtnText1}</div>
            </div>
        )
    }else if(status === 3){
        return (
            <div className="status-wrap">
                <img className="status-logo" src={Resume} />
                <p className="status-title">{i18n.globalStatus.status3Text1}</p>
                <p className="status-subtitle">
                    {i18n.globalStatus.status3Text2 + i18n.globalStatus.status3Text3 + (accessNum >= canVisitsTimes ? 0 : (canVisitsTimes - accessNum)) + i18n.globalStatus.status3Text4}
                </p>
                <div className="status-btn status-btn-fill" onClick={props.hideModal}>{i18n.globalStatus.statusBtnText2}</div>
            </div>
        )
    }else if(status === 4){
        return (
            <div className="status-wrap">
                <img className="status-logo-big" src={Device} />
                <p className="status-title">{i18n.device.title}</p>
                <p className="status-subtitle">{i18n.device.subtitle1 + i18n.device.subtitle2}</p>
                <div className="status-btn status-btn-blank" onClick={handleKickOther}>{i18n.device.kickOtherBtn}</div>
            </div>
        )
    }else if(status === 5){
        return (
            <div className="status-wrap">
                <img className="status-logo-small" src={Offline} />
                <p className="status-content">{i18n.network.title}</p>
                <div className="status-btn status-btn-blank" onClick={props.hideModal}>{i18n.network.btnText}</div>
            </div>
        )
    }else if(status === 6){
        return (
            <div className="status-wrap">
                <img className="status-logo" src={NotSupport} />
                <p className="status-title">{i18n.tips.title}</p>
                <p className="status-subtitle">{i18n.tips.subtitle}</p>
                <div className="status-btn status-btn-blank" onClick={props.hideModal}>{i18n.tips.btnText}</div>
            </div>
        )
    }else if(status === 7){
        return (
            <div className="status-wrap">
                <img className="status-logo" src={Finished} />
                <p className="status-title">{i18n.globalStatus.status4Text1}</p>
                <p className="status-subtitle">{i18n.globalStatus.status4Text2}</p>
                <div className="status-btn status-btn-blank" onClick={props.hideModal}>{i18n.globalStatus.statusBtnText1}</div>
            </div>
        )
    }else if(status === 8){
        return (
            <div className="status-wrap">
                <img className="status-logo" src={NotSupport} />
                <p className="status-title">{i18n.globalStatus.status8Text1}</p>
                <p className="status-subtitle">{i18n.globalStatus.status8Text2}</p>
                <div className="status-btn status-btn-blank" onClick={props.hideModal}>{i18n.globalStatus.statusBtnText1}</div>
            </div>
        )
    }else if(status === 9){
        return (
            <div className="status-wrap">
                <img className="status-logo" src={NotSupport} />
                <p className="status-title">{i18n.globalStatus.status9Text1}</p>
                {isChrome ? <p className="status-subtitle">
                    {i18n.globalStatus.status9Text2 + origin + i18n.globalStatus.status9Text21}
                </p> : null}
                {isFirefox ? <React.Fragment>
                    <p className="status-subtitle">{i18n.globalStatus.status9Text3}</p>
                    <p className="status-subtitle">
                        {i18n.globalStatus.status9Text4 + origin + i18n.globalStatus.status9Text41}
                    </p>
                </React.Fragment> : null}
                {isSafari ? <React.Fragment>
                    <p className="status-subtitle">{i18n.globalStatus.status9Text3}</p>
                    <p className="status-subtitle">{i18n.globalStatus.status9Text5}</p>
                </React.Fragment> : null}
                <div className="status-btn status-btn-blank" onClick={props.hideModal}>{i18n.globalStatus.statusBtnText1}</div>
            </div>
        )
    }else if(status === 10){
        return (
            <div className="status-wrap">
                <img className="status-logo" src={NotSupport} />
                <p className="status-title">{i18n.globalStatus.status7Text1}</p>
                <p className="status-subtitle">{i18n.globalStatus.status7Text2}</p>
                <div className="status-btn status-btn-blank" onClick={props.hideModal}>{i18n.globalStatus.statusBtnText1}</div>
            </div>
        )
    }else{
        return null;
    }
}

export default App;
